export enum ResourceTypeEnum {
  PricePlan = 'price_plan',
  Product = 'physical_product',
  ProductVariant = 'physical_product_variant',
}

export enum TaxBehaviorEnum {
  Inclusive = 'inclusive',
  Exclusive = 'exclusive',
}
